import React, { useState } from 'react';
import axios from 'axios';
import image from '../image/i.png';
import { BASE_URL } from '../../utils/globals';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '24px 16px',
  },
  card: {
    background: '#fff',
    borderRadius: 18,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    textAlign: 'center',
  },
  logo: { width: 72, marginBottom: 20 },
  iconWrap: {
    width: 56, height: 56, borderRadius: '50%',
    background: 'linear-gradient(135deg, #2193b0, #6dd5ed)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, margin: '0 auto 20px',
  },
  title: { fontSize: 22, fontWeight: 700, color: '#1a1a2e', margin: '0 0 8px' },
  sub: { fontSize: 13, color: '#64748b', margin: '0 0 28px', lineHeight: 1.6 },
  label: { fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block', textAlign: 'left' },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1px solid #e2e8f0', borderRadius: 8,
    fontSize: 14, outline: 'none', color: '#1a1a2e',
    background: '#f8fafc', boxSizing: 'border-box',
    marginBottom: 20,
  },
  btn: {
    width: '100%', padding: '12px',
    background: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 15, fontWeight: 600, cursor: 'pointer',
  },
  backLink: {
    display: 'block', textAlign: 'center',
    marginTop: 20, fontSize: 13, color: '#64748b', textDecoration: 'none',
  },
  copy: { textAlign: 'center', fontSize: 12, color: '#94a3b8', marginTop: 28 },
};

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const FALLBACK_BASE_URL = 'https://garen-server.onrender.com';

  const postForgotPassword = async (baseUrl, payload) => {
    const candidates = ['/auth/forgot-password', '/forgot-password'];
    let lastError;

    for (const path of candidates) {
      try {
        return await axios.post(`${baseUrl}${path}`, payload);
      } catch (err) {
        lastError = err;
        // Keep trying only when endpoint is not found.
        if (err?.response?.status !== 404) {
          throw err;
        }
      }
    }

    throw lastError;
  };

  const handleForgotPassword = async () => {
    setLoading(true);
    try {
      await postForgotPassword(BASE_URL, { email });
      toast.success('A reset link has been sent to your email.', {
        position: 'top-right', autoClose: 5000, theme: 'colored',
      });
      setEmail('');
    } catch (error) {
      const isLocalApiError = BASE_URL.includes('localhost') && !error.response;

      if (isLocalApiError) {
        try {
          await postForgotPassword(FALLBACK_BASE_URL, { email });
          toast.success('A reset link has been sent to your email.', {
            position: 'top-right', autoClose: 5000, theme: 'colored',
          });
          setEmail('');
          return;
        } catch (fallbackError) {
          const fallbackMessage = fallbackError?.response?.data?.message || 'Failed to send reset email. Please try again.';
          toast.error(fallbackMessage, {
            position: 'top-right', autoClose: 5000, theme: 'colored',
          });
          return;
        }
      }

      const message = error?.response?.data?.message || 'Failed to send reset email. Please try again.';
      toast.error(message, {
        position: 'top-right', autoClose: 5000, theme: 'colored',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <ToastContainer />
      <div style={s.card}>
        <img src={image} alt='Irivs' style={s.logo} />
        <div style={s.iconWrap}>✉️</div>
        <h2 style={s.title}>Forgot Password?</h2>
        <p style={s.sub}>
          Enter the email associated with your account and we'll send you a link to reset your password.
        </p>

        <label style={s.label}>Email Address</label>
        <input
          style={s.input}
          type='email'
          placeholder='you@example.com'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button style={s.btn} onClick={handleForgotPassword} disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <Link to='/' style={s.backLink}>← Back to Login</Link>

        <p style={s.copy}>Copyright &copy; 2026 Irivs. All rights reserved.</p>
      </div>
    </div>
  );
}

export default ForgotPassword;

